<section class="px-lg md:px-6xl bg-white py-4xl">
  <div class="join-container p-4xl bg-primary-500 rounded-2xl">
    <div class="contraa flex flex-col">
      <div class="flex flex-col">
        <p
          class="bg-buyer-500 mb-2xl px-md py-sm rounded-3xl text-neutral-900 text-small">
          {{
            'landing_page_join_supplier_network_section_business_growth'
              | transloco
          }}
        </p>

        <div class="logo mb-2xl">
          @let name = brandName();
          <!-- The brand name as the card's wordmark. -->
          <svg
            width="215"
            height="36"
            viewBox="0 0 215 36"
            fill="none"
            overflow="visible"
            xmlns="http://www.w3.org/2000/svg">
            <text
              x="9"
              y="31"
              direction="ltr"
              fill="#E5E7EB"
              font-weight="700"
              [attr.font-size]="fontSize(name, 34, 205)">
              {{ name }}
            </text>
          </svg>
        </div>

        <p
          class="bg-supplier-500 financial-success mb-6xl px-md py-sm rounded-3xl text-small text-white">
          {{
            'landing_page_join_supplier_network_section_financial_success'
              | transloco
          }}
        </p>
      </div>
    </div>

    <div class="content text-center text-white">
      <p class="font-semibold mb-sm text-heading-5 title">
        {{ 'landing_page_join_supplier_network_section_title' | transloco }}
      </p>
      <p class="description mb-2xl text-small">
        {{
          'landing_page_join_supplier_network_section_description' | transloco
        }}
      </p>

      <button
        type="button"
        class="bg-primary-50 font-medium px-xl py-sm rounded-sm text-medium text-primary-500">
        {{
          'landing_page_join_supplier_network_section_button_label' | transloco
        }}
      </button>
    </div>
  </div>
</section>
